var _path, _path2, _path3, _path4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInstaLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 198,
    height: 199,
    viewBox: "0 0 198 199",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M99.2815 0.78894H98.8317C44.4151 0.78894 0.301758 44.9153 0.301758 99.3479V99.7978C0.301758 154.23 44.4151 198.357 98.8317 198.357H99.2815C153.698 198.357 197.811 154.23 197.811 99.7978V99.3479C197.811 44.9153 153.698 0.78894 99.2815 0.78894Z",
    fill: "url(#paint0_linear_1_360)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M129.618 40.9837H68.5025C51.6184 40.9837 37.8828 54.7234 37.8828 71.6125V127.54C37.8828 144.429 51.6184 158.169 68.5025 158.169H129.618C146.502 158.169 160.237 144.429 160.237 127.54V71.6125C160.237 54.7234 146.502 40.9837 129.618 40.9837ZM48.6845 71.6125C48.6845 60.683 57.5763 51.7886 68.5025 51.7886H129.618C140.544 51.7886 149.436 60.683 149.436 71.6125V127.54C149.436 138.47 140.544 147.364 129.618 147.364H68.5025C57.5763 147.364 48.6845 138.47 48.6845 127.54V71.6125Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M99.0602 128.059C114.761 128.059 127.542 115.282 127.542 99.5695C127.542 83.8571 114.768 71.0795 99.0602 71.0795C83.3524 71.0795 70.5786 83.8571 70.5786 99.5695C70.5786 115.282 83.3524 128.059 99.0602 128.059ZM99.0602 81.8913C108.81 81.8913 116.74 89.8237 116.74 99.5764C116.74 109.329 108.81 117.262 99.0602 117.262C89.3103 117.262 81.3803 109.329 81.3803 99.5764C81.3803 89.8237 89.3103 81.8913 99.0602 81.8913Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M130.178 75.6824C134.406 75.6824 137.852 72.2423 137.852 68.0062C137.852 63.7701 134.413 60.33 130.178 60.33C125.943 60.33 122.504 63.7701 122.504 68.0062C122.504 72.2423 125.943 75.6824 130.178 75.6824Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_360",
    x1: 29.157,
    y1: 169.493,
    x2: 168.997,
    y2: 29.7008,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAAD4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#DD2A7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#9537B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#515BD4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstaLogo);
export default __webpack_public_path__ + "static/media/insta-logo.6c96612221fd7fedbaddd30521a9d4cc.svg";
export { ForwardRef as ReactComponent };